import { field, text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";

export default class TaxGroup extends BaseModel {
  static table = "tax_groups";
  @text("name") name: string;
  @text("short_name") shortName: string | null;
  @field("arrive_percentage") arrivalPercentage: number;
  @field("sale_percentage") salePercentage: number;
}
